import { render } from "./template.vue?vue&type=template&id=66befc20&scoped=true"
const script = {}

import "./template.vue?vue&type=style&index=0&id=66befc20&lang=scss&scoped=true"

import exportComponent from "/home/circleci/app-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66befc20"]])

export default __exports__